module.exports = __webpack_public_path__ + "media/IndividualPlan/StillOnTrial-e24a8ad1.png";